import React from 'react';

const WhoWeAre = () => {
  return (
    <section className="who-we-are" id="who-we-are">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Why CAEI Exists</h2>
        </div>
        <div className="who-content">
          <div className="who-text">
            <p>
              Many people who experience violence and emotional trauma suffer in silence. Fear, stigma, and lack of access to support services often prevent survivors from seeking the help they need to heal and rebuild their lives.
            </p>
            <p>
              Community Awareness and Empowerment Initiative (CAEI) was created to change that reality. We believe that every person deserves compassion, dignity, and access to support during difficult moments in life.
            </p>
            <p>
              CAEI exists to provide safe, confidential, and free support services to survivors of violence. Through counseling, psychosocial support, and community education, we work to help individuals heal emotionally, regain their strength, and move forward with hope.
            </p>
            <p className="who-highlight">
              At the same time, CAEI works within communities to raise awareness about mental health, reduce stigma, and encourage people to seek support without fear or shame.
            </p>
          </div>
          <div className="who-image">
            <img src="about.png" alt="CAEI Community Work" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
